var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0055 9.35497V9.99945C17.0047 11.5101 16.5155 12.9799 15.611 14.1898C14.7065 15.3998 13.4352 16.2849 11.9866 16.7132C10.5379 17.1415 8.98966 17.0901 7.57265 16.5665C6.15564 16.043 4.94583 15.0755 4.12363 13.8082C3.30143 12.541 2.91091 11.0419 3.0103 9.53453C3.1097 8.02718 3.69368 6.59235 4.67516 5.44402C5.65664 4.29569 6.98303 3.49538 8.45651 3.16247C9.92999 2.82956 11.4716 2.98187 12.8514 3.59669",
    stroke: "#11CE5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0052 4.39453L10 11.4067L7.89844 9.30518",
    stroke: "#11CE5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.5597aae18cf49d452dd20bdd86f541b0.svg";
export { ForwardRef as ReactComponent };